// extracted by mini-css-extract-plugin
export var growableInput = "_88-0";
export var tagContainer = "_88-2";
export var textInput = "_88-1";